interface Product {
  product_name?: string;
  variant_name?: string;
  variant_price?: number;
  base_price?: number;
  quantity?: number;
  [key: string]: any;
}

interface ProductsCellProps {
  products: Product[] | null;
}

export const ProductsCell = ({ products }: ProductsCellProps) => {
  if (!products || products.length === 0) {
    return <span className="text-muted-foreground">-</span>;
  }

  const formatDisplay = (product: Product) => {
    const name = product.product_name ?? "-";
    const variant = product.variant_name ? ` ${product.variant_name}` : "";
    const price = product.variant_price ?? product.base_price;
    const priceText = price !== undefined ? price.toLocaleString() : "-";

    return `${name}${variant} - ${priceText}`;
  };

  return (
    <div className="space-y-1 text-sm text-muted-foreground">
      {products.map((product, index) => (
        <div key={`${product.product_name ?? "product"}-${index}`}>
          {formatDisplay(product)}
        </div>
      ))}
    </div>
  );
};
